import React from 'react'

export default function VerticalDots() {
    return (
        <svg 
        className="w-6 h-6 text-gray-600 " 
        aria-hidden="true" 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24">
            <path stroke="currentColor" strokeLinecap="round" strokeWidth="1.6" d="M12 6h0m0 6h0m0 6h0" />
        </svg>
    )
}
